import { type ReactNode, createContext, useContext, useMemo } from 'react';
import type { FaarenListCar } from '../_tools/types/faaren';

const AllFaarenVehiclesContext = createContext<FaarenListCar[]>(undefined);

export const useAllFaarenVehiclesContext = () => {
    const context = useContext(AllFaarenVehiclesContext);
    return context;
};

type AllFaarenVehiclesProviderProps = {
    children: ReactNode;
    initAllFaarenVehicles: FaarenListCar[];
};

export function AllFaarenVehiclesProvider({ children, initAllFaarenVehicles }: AllFaarenVehiclesProviderProps) {
    const memoizedValue = useMemo(
        () => initAllFaarenVehicles,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return <AllFaarenVehiclesContext.Provider value={memoizedValue}>{children}</AllFaarenVehiclesContext.Provider>;
}
